export const styles = {
  button: (canSelect: boolean) => ({
    cursor: canSelect ? 'pointer' : 'default',
    justifyContent: 'start',
  }),
};
